import script from "./TermsAndConditions.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsAndConditions.vue?vue&type=script&setup=true&lang=ts"

import "./TermsAndConditions.vue?vue&type=style&index=0&id=0783c72a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0783c72a"]])

export default __exports__